module.exports = __webpack_public_path__ + "static/img/europe-logo.0267703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/europe-logo.jpg
// module id = 7qbX
// module chunks = 1